<template>
  <div>
    <ca-header heading="Kaufschutz Tarif">
      <template #alert>
        <transition name="slide-fade">
          <ca-alert
            v-if="!!saveErrorMessage"
            variant="danger"
            :message="saveErrorMessage"
            @close="saveErrorMessage = null"
          />
        </transition>
        <transition name="slide-fade">
          <ca-alert
            v-if="!!saveSuccessMessage"
            variant="success"
            :message="saveSuccessMessage"
            @close="saveSuccessMessage = null"
          />
        </transition>
        <transition name="slide-fade">
          <ca-alert
            v-if="showFormInvalidHint"
            variant="info"
            message="Es sind noch nicht alle erforderlichen Felder ausgefüllt"
            @close="showFormInvalidHint = null"
          />
        </transition>
      </template>
      <template #buttonSpace>
        <button
          class="btn btn-success text-white"
          @click="save()"
        >
          Speichern
        </button>
      </template>
    </ca-header>
    <div class="container-fluid px">
      <KaufschutzForm
        v-if="!loading"
        :kaufschutz-rate="kaufschutzRate"
      />
    </div>
  </div>
</template>

<script>
import CaHeader from '@/components/Layout/Header'
import KaufschutzForm from './components/KaufschutzForm.vue'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },
  name: 'KaufschutzRateCreate',
  components: {
    CaHeader,
    KaufschutzForm
  },
  data () {
    return {
      loading: false,
      loadingError: null,
      kaufschutzRate: null,
      savePending: false,
      saveError: null,
      saveSuccessMessage: null,
      saveErrorMessage: null,
      showFormInvalidHint: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: 'fetchData'
    }
  },
  methods: {
    async fetchData () {
      try {
        this.loading = true
        this.kaufschutzRate = new this.$FeathersVuex.api.KaufschutzRate()
        this.kaufschutzRate.product = new this.$FeathersVuex.api.Product()
      } catch (error) {
        this.loadingError = error
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async save () {
      try {
        const valid = await this.$validator.validateAll()
        if (this.userSavePending) {
          return
        }
        if (!valid) {
          this.showFormInvalidHint = true
          return
        }
        this.savePending = true
        this.saveErrorMessage = null
        this.showFormInvalidHint = false
        await this.kaufschutzRate.save()
        this.savePending = false
        this.saveSuccessMessage = 'Speichern erfolgreich'
        await this.$router.push({ name: 'KaufschutzRateList' })
      } catch (error) {
        this.saveErrorMessage = error.message
        this.saveError = error
        console.error(error)
      } finally {
        this.savePending = false
      }
    }
  }
}
</script>
